var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"copyright dimColor",attrs:{"id":"copyright"}},[_vm._v(" Fredrik Wendel. Copyright © 2011-"+_vm._s(_vm.currentYear())+" All rights reserved! ")])}
var staticRenderFns = []

export { render, staticRenderFns }